import httpClient from "../axiosBase/axiosHandler";

// Sends a POST request to export the profit and loss report with the provided data
export const getProfitAndLossReport = (data) => {
  return httpClient.post("metrics/export-profit-lost-report/", data);
};
